import { useEffect, useState } from 'react'
import Tooltip from '../common/Tooltip'
import DeleteModal from '../common/DeleteModal'
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { useFirestoreNoCompagnyGeneralArrayContains } from '../../firebase/useFirestore'
import { db } from '../../firebase/config'
import { client } from '../../hooks/Client'
import firebase from '../../firebase/compat'

const DeleteIndicator = ({ field }) => {
    // State
  const [deleteModal, setDeleteModal] = useState(false)
  const [deleteName, setDeleteName] = useState('')
  const [syncID, setSyncID] = useState(null)
  const [deleteModalSync, setDeleteModalSync] = useState(false)
  const [deleteDocid, setDeleteDocid] = useState('')

  // Firestore
  const syncs = useFirestoreNoCompagnyGeneralArrayContains('Synchronisations', 'ProjectQuestion', field?.ID || '', 'Members', client)

  // Set sync ID
  useEffect(() => {
      if (syncs.length > 0) {
          setSyncID(syncs[0].ID)
      }
  }, [syncs])

      // Delete modal 
    const deleteModalHandler = (e) => {
        const docid = e.currentTarget.dataset.docid
        const deleteName = e.currentTarget.dataset.deletename

        setDeleteDocid(docid)
        setDeleteName(deleteName)

        setDeleteModal(!deleteModal)
    }

    const deleteQuestion = (e) => {

        // Remove effectId from field
        db.collection('QuestionnaireFields')
        .doc(deleteDocid)
        .update({
            EffectId: firebase.firestore.FieldValue.arrayRemove(field?.EffectId[0])
        })
    }

  // Delete modal syncs
    const deleteModalSyncHandler = (e) => {
        const docid = e.currentTarget.dataset.docid
        const deleteName = e.currentTarget.dataset.deletename

        setDeleteDocid(docid)
        setDeleteName(deleteName)

        console.log('Deleting sync:', deleteName)

        setDeleteModalSync(!deleteModalSync)
    }

    const isStandard = field?.Standard === true || field?.Standard === 'true';
    const content = isStandard ? 'Let op! Gestandaardiseerde indicatoren kunnen niet worden verwijderd' : 'Indicator verwijderen';
    const top = isStandard ? '-100px' : '-60px';
    const width = isStandard ? undefined : '80%';
    const onClick = isStandard ? undefined : (syncID ? deleteModalSyncHandler : deleteModalHandler);

    // Een indicator 'verwijderen' koppelt hem alleen los van zijn effect (zie
    // deleteQuestion): de vraag blijft bestaan. Het venster zegt dat, in plaats
    // van 'definitief' en 'kan niet ongedaan'.
    // AI-CONTEXT: See docs/pitfalls.md#ui-soft-delete-promises-a-trash-it-is-not-in
    const UNLINK_NOTE = 'De vraag zelf blijft bestaan; alleen de koppeling met dit effect verdwijnt.'

    // Update synchronisation
    const updateSync = () => {
       db.collection('Synchronisations')
        .where('ID', '==', syncID)
        // Tenant-scope + secure against the Members-based Synchronisations rule.
        // AI-CONTEXT: See docs/pitfalls.md#security-synchronisations-members-tenant-gate
        .where('Members', 'array-contains', client)
        .get()
        .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                db.collection('Synchronisations')
                .doc(doc.id)
                .update({
                    Status: 'deleted-project'
                })
            })
        })
    }


    // Met een actieve synchronisatie: loskoppelen én de koppeling markeren.
    const confirmSyncedDelete = () => {
        deleteQuestion()
        updateSync()
    }

  return (
    <div>
        <Tooltip content={content} top={top} width={width}>
        <DeleteOutlinedIcon
            className="table-delete-icon"
            data-docid={field.docid}
            data-deletename={field.Question}
            {...(onClick ? { onClick } : {})}
        />
        </Tooltip>
        <DeleteModal deleteModal={deleteModal} setDeleteModal={setDeleteModal} deleteItem={deleteQuestion} deleteName={deleteName} undoNote={UNLINK_NOTE} />
        <DeleteModal deleteModal={deleteModalSync} setDeleteModal={setDeleteModalSync} deleteItem={confirmSyncedDelete} deleteName={deleteName} undoNote={UNLINK_NOTE} activeSync />
    </div>
  )
}

export default DeleteIndicator